// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import {IProductEnvironment} from "./FacilitiesEvaluationEnvironment";
import {EProductType} from "../javascript.lib.mojo-base/model/ProductType";
import {FacilityAccessibilityProduct4} from "../product.facility/model/FacilityAccessibilityProduct4";

export const environment: IProductEnvironment = {

  name: 'Technology Team: Facilities',
  filename: 'environment.facilities-77778484.ts',

  isDevelopment: false,
  isProduction: true,
  isTest: false,

  authenticationConfig: {

    emailLink: false,
    textMessage: false,
    usernamePassword: true
  },

  firebaseConfig: {
    apiKey: "AIzaSyAQIC3z_XBirNfFXb7aaYBHQl3XuiYkDYw",
    authDomain: "facilities-77778484.firebaseapp.com",
    databaseURL: "https://facilities-77778484-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "facilities-77778484",
    storageBucket: "facilities-77778484.appspot.com",
    messagingSenderId: "634119468924",
    appId: "1:634119468924:web:c53f84c742fb3fadf816f9"
  },

  // curl -iLS https://us-central1-$_TARGET_ENV.cloudfunctions.net/public/functions/info
  cloudFunctionsUrl: 'https://us-central1-facilities-77778484.cloudfunctions.net',

  nocoDbConfig: {
    // httpServer: 'http://localhost:8080',
    httpServer: 'https://mobilitymojo-spot.com',
    user: 'test@mobilitymojo.com',
    password: 'test@mobilitymojo.com',
    authorization: 'Basic bW9iaWxpdHk6bW9qbw==',
    projectTitle: '2024 - Grosvenor and The Crown Estate',
  },

  productConfig: {

    firebaseAnswersRoot: '/answers-x/facilities',
    product:  FacilityAccessibilityProduct4.INSTANCE,
    productType: EProductType.facilities,
    canCommentOnClusters: true,
    canEditClusters: false,
    clusterSupport: true,

  },

  preview: {
    fireworksEnabled: true,
  },
};
